import initPopup from '@components/popup';

// Init Carousel on DomContentLoaded
document.addEventListener( 'DOMContentLoaded', () => {
	initPopup( document );
} );

// Enable HMR
if ( module.hot ) {
	module.hot.accept();
}
